module.exports = "<div id=\"map\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/map/map.component.html
// module id = 393
// module chunks = 1